import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
//components
import SendEmail from "./SendEmail.jsx";
//image
import logo from "../../assets/logo.png";
import darkLogo from "../../assets/darkLogo.png";
import img from "../../assets/default.jpg";
//imports
import { validadeLogin } from "../../services/Login/validadeLogin.js";
import { login } from "../../utils/auth.js";
import { useAppContext } from "../../context/AppContext.jsx";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const { id } = useParams(); //get id
  const { doc } = location.state; //get doc

  const [foto, setFoto] = useState(logo);
  const [loading, setLoading] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const openEye = () => {
    setShowPassword(!showPassword);
  };

  const getDark = localStorage.getItem("appDarkMode");
  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
    setMenu,
    setNomenclatures,
    setPermissions,
    setProfilePhoto,
  } = useAppContext();

  useEffect(() => {
    if (getDark === "true") {
      setFoto(logo);
    } else {
      if (window.innerWidth <= 992) {
        setFoto(logo);
      } else {
        setFoto(darkLogo);
      }
    }
  }, [getDark]);

  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    return () => {
      handleSetAppSidebarNone(false);
      handleSetAppHeaderNone(false);
      handleSetAppContentClass("");
    };
  }, [
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  ]);

  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);

    const { password } = data;

    const validade = {
      doc: doc,
      password: password,
      user_id: id,
    };

    if (!validade.password) {
      toast.warning("Insira a senha!");
      setLoading(false);
      return;
    }
    try {
      const response = await validadeLogin(validade);

      // console.log(response);
      /*
        Status
        0 - Inativo
        1 - Ativo
        2 - Bloqueado Pelo admin
        3 - Pagamento Pendente
        4 - Erro ao tentar realizar cobrança
        5 - Aguardando Todos os signatarios assinar o documento
        6 - Ambiente em teste gratis
        7 - Ambiente em teste gratis pendente de verificação de codigo
        8 - Assinatura expirada
      */
      switch (response.environment_status) {
        case 0:
          toast.warning(
            "O sistema não está disponível no momento, contate um administrador"
          );
          return;
        case 1:
          if (response.profile_photo) {
            setProfilePhoto(response.profile_photo.path);
          } else {
            setProfilePhoto(img);
          }

          login(
            response.token,
            response.name,
            response.id,
            response.role,
            response.profile_photo ? response.profile_photo.path : img,
            response.ib_plan,
            response.daysRemaining || false,
            response.environment_id
          );

          setPermissions(JSON.stringify(response.permissions));

          let nomenclatures;

          if (response.nomenclature) {
            nomenclatures = [
              {
                value: response.nomenclature.nomenclature_block,
                label: response.nomenclature.nomenclature_block,
              },
              {
                value: response.nomenclature.nomenclature_land,
                label: response.nomenclature.nomenclature_land,
              },
            ];
          } else {
            nomenclatures = [
              { value: "Quadra", label: "Quadra" },
              { value: "Lote", label: "Lote" },
            ];
          }

          let navbar = JSON.stringify(nomenclatures);
          setNomenclatures(navbar);
          localStorage.setItem("nomenclatures", navbar);
          
          let menu = JSON.stringify(response.navbar);
          setMenu(menu);

          if (response.role === "ibSystem") {
            navigate("/admin");
          } else {
            if (
              response.permissions &&
              typeof response.permissions === "object"
            ) {
              if (response.permissions.hasOwnProperty("5")) {
                navigate("/dashboard");
                return;
              }
              if (response.permissions.hasOwnProperty("13")) {
                navigate("/salesManagement");
                return;
              }
            }
            navigate("/myAccount");
          }
          break;
        case 2:
          toast.warning(
            "O sistema não está disponível no momento, contate um administrador"
          );
          return;
        case 3:
          if (response.role === "Admin") {
            if (response.profile_photo) {
              setProfilePhoto(response.profile_photo.path);
            } else {
              setProfilePhoto(img);
            }


            login(
              response.token,
              response.name,
              response.id,
              response.role,
              response.profile_photo ? response.profile_photo.path : img,
              response.ib_plan,
              response.daysRemaining || false,
              response.environment_id
            );

            setPermissions(JSON.stringify({ 1: "Visualizar Area do Cliente" }));

            let nomenclatures;

            if (response.nomenclature) {
              nomenclatures = [
                {
                  value: response.nomenclature.nomenclature_block,
                  label: response.nomenclature.nomenclature_block,
                },
                {
                  value: response.nomenclature.nomenclature_land,
                  label: response.nomenclature.nomenclature_land,
                },
              ];
            } else {
              nomenclatures = [
                { value: "Quadra", label: "Quadra" },
                { value: "Lote", label: "Lote" },
              ];
            }

            let navbar = JSON.stringify(nomenclatures);
            setNomenclatures(navbar);
            localStorage.setItem("nomenclatures", navbar);
            let menu = JSON.stringify(response.navbar);

            setMenu(menu);

            navigate("/userRegistration", { state: { index: 0 } });
            return;
          } else {
            toast.warning(
              "O sistema não está disponível no momento, contate um administrador"
            );
            return;
          }
        case 4:
          if (response.role === "Admin") {
            if (response.profile_photo) {
              setProfilePhoto(response.profile_photo.path);
            } else {
              setProfilePhoto(img);
            }

            login(
              response.token,
              response.name,
              response.id,
              response.role,
              response.profile_photo ? response.profile_photo.path : img,
              response.ib_plan,
              response.daysRemaining || false,
              response.environment_id
            );

            setPermissions(JSON.stringify({ 1: "Visualizar Area do Cliente" }));

            let nomenclatures;

            if (response.nomenclature) {
              nomenclatures = [
                {
                  value: response.nomenclature.nomenclature_block,
                  label: response.nomenclature.nomenclature_block,
                },
                {
                  value: response.nomenclature.nomenclature_land,
                  label: response.nomenclature.nomenclature_land,
                },
              ];
            } else {
              nomenclatures = [
                { value: "Quadra", label: "Quadra" },
                { value: "Lote", label: "Lote" },
              ];
            }

            let navbar = JSON.stringify(nomenclatures);
            setNomenclatures(navbar);
            localStorage.setItem("nomenclatures", navbar);
            let menu = JSON.stringify(response.navbar);

            setMenu(menu);

            navigate("/userRegistration", { state: { index: 0 } });
            return;
          } else {
            toast.warning(
              "O sistema não está disponível no momento, contate um administrador"
            );
            return;
          }
        case 5:
          if (response.role === "Admin") {
            login(
              response.token,
              response.name,
              response.id,
              response.role,
              response.profile_photo ? response.profile_photo.path : img,
              response.ib_plan,
              response.daysRemaining || false,
              response.environment_id
            );
            navigate(`/success`, { state: { plan: response.plan } });
            return;
          } else {
            toast.warning(
              "O sistema não está disponível no momento, contate um administrador"
            );
            return;
          }
        case 6:
          try {
            const profilePhotoPath = response.profile_photo?.path || img;
            setProfilePhoto(profilePhotoPath);

            login(
              response.token,
              response.name,
              response.id,
              response.role,
              profilePhotoPath,
              response.ib_plan,
              response.daysRemaining || false,
              response.environment_id
            );

            setPermissions(JSON.stringify(response.permissions));

            let nomenclaturesFree;

            if (response.nomenclature) {
              nomenclaturesFree = [
                {
                  value: response.nomenclature.nomenclature_block,
                  label: response.nomenclature.nomenclature_block,
                },
                {
                  value: response.nomenclature.nomenclature_land,
                  label: response.nomenclature.nomenclature_land,
                },
              ];
            } else {
              nomenclaturesFree = [
                { value: "Quadra", label: "Quadra" },
                { value: "Lote", label: "Lote" },
              ];
            }

            let navbarFree = JSON.stringify(nomenclaturesFree);
            setNomenclatures(navbarFree);
            localStorage.setItem("nomenclatures", navbarFree);
            let menu = JSON.stringify(response.navbar);
            setMenu(menu);

            if (response.role === "ibSystem") {
              navigate("/admin");
            } else {
              if (
                response.permissions &&
                typeof response.permissions === "object"
              ) {
                if (response.permissions.hasOwnProperty("5")) {
                  navigate("/dashboard");
                  return;
                }
                if (response.permissions.hasOwnProperty("13")) {
                  navigate("/salesManagement");
                  return;
                }
              }
              navigate("/myAccount");
            }
          } catch (error) {
            console.log(error);
          }
          break;
        case 8:
          if (response.role === "Admin") {
            if (response.profile_photo) {
              setProfilePhoto(response.profile_photo.path);
            } else {
              setProfilePhoto(img);
            }

            login(
              response.token,
              response.name,
              response.id,
              response.role,
              response.profile_photo ? response.profile_photo.path : img,
              response.ib_plan,
              response.daysRemaining || false,
              response.environment_id
            );

            setPermissions(JSON.stringify({ 1: "Visualizar Area do Cliente" }));

            let nomenclatures;

            if (response.nomenclature) {
              nomenclatures = [
                {
                  value: response.nomenclature.nomenclature_block,
                  label: response.nomenclature.nomenclature_block,
                },
                {
                  value: response.nomenclature.nomenclature_land,
                  label: response.nomenclature.nomenclature_land,
                },
              ];
            } else {
              nomenclatures = [
                { value: "Quadra", label: "Quadra" },
                { value: "Lote", label: "Lote" },
              ];
            }

            let navbar = JSON.stringify(nomenclatures);
            setNomenclatures(navbar);
            localStorage.setItem("nomenclatures", navbar);
            let menu = JSON.stringify(response.navbar);

            setMenu(menu);

            toast.warning("Seu teste grátis chegou ao fim");
            navigate("/success", { state: { activation: true } });
            return;
          } else {
            toast.warning(
              "O sistema não está disponível no momento, contate um administrador"
            );
            return;
          }
        default:
          if (response.error && response.error.code === 7) {
            toast.warning("Valide o email para acessar o sistema!");
            navigate("/verify", {
              state: { environment_id: response.error.data },
            });
            return;
          }
          if (response.error && response.code === 2) {
            toast.warning(
              "O sistema não está disponível no momento, contate um administrador"
            );
            return;
          }
          if (response.error && response.code === 6) {
            toast.warning("Seu teste grátis chegou ao fim");
            navigate("/success", { state: { activation: true } });
            return;
          }
          toast.warning(
            "O sistema não está disponível no momento, contate um administrador"
          );
          return;
      }
    } catch (error) {
      toast.error("Senha invalida!");
      reset({ password: "" });
    } finally {
      setLoading(false);
    }
  };

  function handleSendEmail() {
    setSendEmail(!sendEmail);
  }

  return (
    <>
      <div className="login login-v1">
        <div className="login-container">
          <div className="login-header">
            <div className="brand">
              <div className="d-flex align-items-center">
                <img src={foto} width={250} alt="Logo IB3 Capital" />
              </div>
            </div>
            <div className="icon">
              <i className="fa fa-lock"></i>
            </div>
          </div>
          <div className="login-body">
            <div className="login-content fs-13px">
              {!sendEmail && (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-floating mb-20px position-relative">
                    <input
                      autoFocus
                      id="new-password"
                      className="form-control fs-13px h-45px"
                      type={showPassword ? "text" : "password"}
                      {...register("password")}
                    />
                    <div
                      onClick={openEye}
                      className="position-absolute top-0 mt-2 end-0 p-2"
                    >
                      {showPassword ? (
                        <i className="fa-solid fa-eye"></i>
                      ) : (
                        <i className="fa-solid fa-eye-slash"></i>
                      )}
                    </div>
                    <label
                      htmlFor="new-password"
                      className="d-flex align-items-center py-0"
                    >
                      Senha
                    </label>
                  </div>
                  <div className="login-buttons">
                    <button
                      disabled={loading}
                      type="submit"
                      className="btn h-45px btn-blue d-flex align-items-center justify-content-center w-100 btn-lg"
                    >
                      {loading ? (
                        <ThreeDots
                          height="80"
                          width="80"
                          radius="9"
                          color="#fff"
                          ariaLabel="three-dots-loading"
                          wrapperStyle={{}}
                          wrapperClassName=""
                          visible={true}
                        />
                      ) : (
                        <>Entrar</>
                      )}
                    </button>

                    <div className="text-center pt-2">
                      <b>
                        <div
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={handleSendEmail}
                          className="text-gray bg-transparent border-none"
                        >
                          Esqueceu a senha ?{" "}
                          {/* <i className="fas fa-arrow-right ml-1"></i> */}
                        </div>
                      </b>
                    </div>
                  </div>
                </form>
              )}
              {sendEmail && <SendEmail />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
